module.exports = __webpack_public_path__ + "static/carlight-5558b3332dbf832edeece09d079b3e74.jpg";